






















































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import JsonResource from "@/components/common/Debug/JsonResource.vue";
import LabelCount from "@/views/Service/TimeTracking/Customers/Overview/Customer/LabelCount.vue";
import LabelDurationAsHours from "@/views/Service/TimeTracking/Customers/Overview/Customer/LabelDurationAsHours.vue";
import ReloadButton from "@/components/Buttons/ReloadButton.vue";

const NAMESPACE_TIME_TRACKING_RECORD: string = 'timeTrackingRecords';
const RESOURCE_TIME_TRACKING_RECORD: string = 'tt/record';
const NAMESPACE_TIME_TRACKING_CUSTOMERS: string = 'timeTrackingCustomers';
const RESOURCE_TIME_TRACKING_CUSTOMERS: string = 'tt/customers';
const RESOURCE_TIME_TRACKING_BRANDS: string = 'tt/brand';
const NAMESPACE_TIME_TRACKING_TASKS: string = 'timeTrackingTasks';
@Component({
  components: {ReloadButton, LabelDurationAsHours, LabelCount, JsonResource}
})
export default class CustomerView extends Vue {
  public name: string = "CustomerView";

  @Action('loadItem', {namespace: NAMESPACE_TIME_TRACKING_CUSTOMERS}) loadCustomerItemAction: any;
  @Action('load', {namespace: NAMESPACE_TIME_TRACKING_TASKS}) loadBrandsTasksAction: any;

  @Getter('getItem', {namespace: NAMESPACE_TIME_TRACKING_CUSTOMERS}) getCustomerItem: any;
  @Getter('getDataList', {namespace: NAMESPACE_TIME_TRACKING_TASKS}) getBrandsTasks: any;
  @Getter('isLoading', {namespace: NAMESPACE_TIME_TRACKING_CUSTOMERS}) isLoading: any;
  @Getter('isLoading', {namespace: NAMESPACE_TIME_TRACKING_TASKS}) isBrandsTasksLoading: any;

  @Watch('selectedBrandId', {immediate: true})
  private onSelectedBrandIdChanged(newVal: number): void {
    if (newVal > -1) {
      this.loadBrandsTasks();
    }
  }

  private selectedBrandId: number = -1;

  private get customer(): any {
    return this.getCustomerItem;
  }

  private get brandsTasks(): any {
    return this.getBrandsTasks ?? [];
  }

  private get resourceBrandsTimeTrackingTasks(): string {
    return RESOURCE_TIME_TRACKING_BRANDS + '/' + String(this.selectedBrandId) + '/tasks'
  }

  private loadCustomer(): void {
    this.loadCustomerItemAction({
      resource: RESOURCE_TIME_TRACKING_CUSTOMERS,
      id: this.$route.params.id
    });
  }

  private loadBrandsTasks(): void {
    // removed console_log
    if (this.selectedBrandId > -1) {
      this.loadBrandsTasksAction({
        resource: this.resourceBrandsTimeTrackingTasks
      });
    }
  }

  private onClickReload(): void {
    this.loadCustomer();
    this.loadBrandsTasks();
  }

  private onSelectBrand(brandId: number) {
    this.selectedBrandId = brandId;
  }

  created() {
    this.loadCustomer();
  }

}
